import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import Routes from "./routes";
import "./assets/css/bootstrap.css";
import "./assets/css/style.css";
import "./components/global.js";
import { applyFavicon, getCompanyLogo, loadCompany } from "./services/company.service.js";

/* โลโก้บริษัทใช้ทั้ง navbar หน้า login ฟุตเตอร์เว็บลูกค้า และ favicon
   ติด favicon จากค่าที่ cache ไว้ก่อน (แท็บจะได้ไม่กะพริบเป็นไอคอนตั้งต้น)
   แล้วค่อยดึงค่าล่าสุดครั้งเดียวต่อการเปิดเว็บ — ทุกจุดที่ใช้ <Logo /> อัปเดตตาม */
applyFavicon(getCompanyLogo());
loadCompany();

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <BrowserRouter>
    <div className="spinner-container" id="loading">
      <div className="loading-spinner"></div>
    </div>
    <Routes />
  </BrowserRouter>,
);
